// extracted by mini-css-extract-plugin
module.exports = {"checkbox-container":"checkbox-m__checkbox-container__1reE2","checkmark":"checkbox-m__checkmark__1TMb_","label":"checkbox-m__label__1FvkR"};